import React, { useEffect, useRef, useState } from 'react'
import IsecNavbar from './IsecNavbar'
import './pages-css/User.css'
import { toast } from 'react-toastify'
import { useAuth } from '../../Context/UserContext'
import { faCaretDown, faCaretUp, faChevronDown, faChevronUp, faMagnifyingGlass, faTrash, faTrashCan, faUserPen, faUserPlus, faXmark } from '@fortawesome/free-solid-svg-icons'
import { faCalendar, faEnvelope, faUser } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FiBriefcase } from "react-icons/fi";
import IsecNavbar2 from './IsecNavbar2'
import { Icon } from '@iconify/react'
import { url } from '../../constants/url'
import { useNavigate } from 'react-router-dom'
import ClientNavbar1 from '../../Client-components/Pages/ClientNavbar1'
import SearchBar from '../Modal/SearchBar'
import GroupBy from '../Modal/GroupBy'
import TableSkeleton from '../Skeleton/Table'
import { Delete } from '../../Client-components/Modal/Delete'
import RegisterUser from '../Modal/RegisterUser'
import Feedback from '../Modal/Feedback'


function User() {

    const [openRegUser, setOpenRegUser] = useState(false)

    const [searchUserQuery, setSearchUserQuery] = useState('');
    const [inputFocused, setInputFocused] = useState(false);
    const [isLoading, setIsLoading] = useState(false);


    const { logout, userRole, emailVer, isSidebarCollapsed } = useAuth('')


    const [registerData, setRegisterData] = useState([])
    const [userQuery, setUserQuery] = useState('')
    const [openUserDropdown, setOpenUserDropdown] = useState(false)
    const [userTypeFilter, setUserTypeFilter] = useState("All");
    const filterUserRef = useRef(null)
    const [currentPage, setCurrentPage] = useState(1);

    const [deleteUser, setDeleteUser] = useState(false)
    const [selectedUserId, setSelectedUserId] = useState(null);

    const [openFeedbackForm, setOpenFeedbackForm] = useState(false)


    const specialChars = /[!@#$%^&*(),.?":{}|<>]/;

    const navigate = useNavigate()


    const handleOpenRegUser = () => {
        setOpenRegUser(true)
    }

    const handleOpenFeedback = () => {
        setOpenFeedbackForm(true)
    }



    useEffect(() => {

        if (!emailVer.endsWith('@isecurion.com') || userRole !== 'manager') {
            logout();
            return;
        }
    }, []);


    // Refer users.js file for backend code

    const fetchRegisterUser = async () => {
        try {
            const response = await fetch(`${url}/fetchregisteruser`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include'
            })
            const data = await response.json()
            setRegisterData(data)

            if (response.status === 440) {
                logout()
                toast.error("User logout due to inactivity", {
                    position: 'top-right',
                    autoClose: 2500,
                    pauseOnHover: false,
                });
                return
            }

        } catch (error) {
            console.log(error)
        }
    }

    const handleResendForgetLink = async (id) => {
        try {
            const response = await fetch(`${url}/resend_create_account_link`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify({
                    userId: id
                })
            })
            if (response.status === 200) {
                toast.success('Mail sent successfully...', {
                    position: 'top-right',
                    autoClose: 2500,
                    pauseOnHover: false,
                });
                return
            }
            if (response.status === 400) {
                toast.error("Bad Request", {
                    position: 'top-right',
                    autoClose: 2500,
                    pauseOnHover: false,
                });
                return
            }
            if (response.status === 404) {
                toast.error("User not found", {
                    position: 'top-right',
                    autoClose: 2500,
                    pauseOnHover: false,
                });
                return
            }
            if (response.status === 429) {
                toast.error("Contact administrator", {
                    position: 'top-right',
                    autoClose: 2500,
                    pauseOnHover: false,
                });
                return
            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        fetchRegisterUser()
    }, [])

    const formatDate = (dateString) => {
        const options = { day: '2-digit', month: '2-digit', year: 'numeric' }
        const date = new Date(dateString)
        return date.toLocaleDateString('en-GB', options)
    }

    const handleDeleteUser = async () => {
        try {
            const response = await fetch(`${url}/deleteregisteruser`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify({
                    userId: selectedUserId
                })
            })

            if (response.ok) {
                toast.success('User deleted successfully...', {
                    position: 'top-right',
                    autoClose: 2500,
                    pauseOnHover: false,
                });
                fetchRegisterUser()
                setDeleteUser(false)
            }
            if (response.status === 404) {
                toast.error('User not found', {
                    position: 'top-right',
                    autoClose: 2500,
                    pauseOnHover: false,
                });
            }
            if (response.status === 440) {
                logout()
                toast.error("User logout due to inactivity", {
                    position: 'top-right',
                    autoClose: 2500,
                    pauseOnHover: false,
                });
                return
            }

        } catch (error) {
            console.log(error)
        }
    }

    const userPerPage = 15;
    const startIndex = (currentPage - 1) * userPerPage + 1;
    const endIndex = startIndex + userPerPage;

    const handleUserSearchInput = (event) => {
        setUserQuery(event.target.value)
    }

    const getTotalUserPages = () => {
        return Math.ceil((registerData ?? []).length / userPerPage);
    };

    const getPageUsers = () => {
        if (!registerData) {
            return [];
        }
        const slicedUsers = registerData.slice(startIndex - 1, endIndex - 1);

        return slicedUsers.map((user, index) => ({
            ...user,
            slNo: startIndex + index,
        }));
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < getTotalUserPages()) {
            setCurrentPage(currentPage + 1);
        }
    };

    const filteredUsers = registerData.filter((user) => {
        const matchesUser =
            user.name.toLowerCase().includes(userQuery.toLowerCase()) ||
            user.email.toLowerCase().includes(userQuery.toLowerCase());

        const isIsecurionUser = user.email && user.email.endsWith("isecurion.com");

        // Apply filter based on selected user type
        if (userTypeFilter === "Isecurion" && !isIsecurionUser) return false;
        if (userTypeFilter === "Client" && isIsecurionUser) return false;


        return matchesUser
    })

    const sortedUsers = [...filteredUsers].sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    );

    const handleClickUserOut = (event) => {
        if (filterUserRef.current && !filterUserRef.current.contains(event.target)) {
            setOpenUserDropdown(false)
        }
    }



    useEffect(() => {
        if (openUserDropdown) {
            document.addEventListener('mousedown', handleClickUserOut);
        } else {
            document.removeEventListener('mousedown', handleClickUserOut);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickUserOut);
        }
    }, [openUserDropdown])

    return (
        <div className="isecurion-user-table">
            <div>
                <div className='client_navabr1'>
                    <ClientNavbar1 />
                </div>
                <div className='isecurion_navbar_second'><IsecNavbar2 /></div>
            </div>

            <div className='wrap_isecurion_navbar_usertable'>
                <div className={isSidebarCollapsed ? 'isecuriondash-navbar' : 'isecuriondash_close_navbar'}>
                    <IsecNavbar />
                </div>
                <div className={isSidebarCollapsed ? 'wrap_isecurion_dashboard_data_open' : 'wrap_isecurion_dashboard_data'} >
                    <div className="isecDashboard_user_page_container">
                        <div className="isecDashboard_user_page_heading">
                            View and add users
                        </div>

                        <div className="isecDashboard_user_page_filter_container">
                            <div className="isecDashboard_user_page_search_container">
                                <SearchBar
                                    placeholder={"Search Users..."}
                                    setSearchText={setUserQuery}
                                />
                            </div>
                            <div className='isecDashboard_user_page_adduser_and_group_container'>
                                <div className='add_button_feedback'>
                                    <button onClick={handleOpenFeedback}>Feedback</button>
                                </div>

                                <div className="add_button_feedback">
                                    <button onClick={() => handleOpenRegUser()}>Create Account</button>
                                </div>
                            </div>

                        </div>
                        <div className="isecDashboard_user_page_table_container">
                            <table>
                                <thead>
                                    <tr>
                                        <th>SI No</th>
                                        <th>Name</th>
                                        <th>
                                            <span className="isecDashboard_user_table_header">
                                                <Icon
                                                    icon="carbon:email"
                                                    width="19"
                                                    height="19"
                                                    color="black"
                                                />
                                                <span>Email ID</span>
                                            </span>
                                        </th>
                                        <th>
                                            <span className="isecDashboard_user_table_header">
                                                <Icon
                                                    icon="proicons:person"
                                                    width="19"
                                                    height="19"
                                                    color="black"
                                                />
                                                <span>User</span>
                                            </span>
                                        </th>
                                        <th>
                                            <span className="isecDashboard_user_table_header">
                                                {/* <Icon
                                                    icon="proicons:person"
                                                    width="19"
                                                    height="19"
                                                    color="black"
                                                /> */}
                                                <span>Role</span>
                                            </span>
                                        </th>
                                        <th>
                                            <span className="isecDashboard_user_table_header">
                                                <Icon
                                                    icon="formkit:date"
                                                    width="19"
                                                    height="19"
                                                    color="black"
                                                />
                                                <span>Created Date</span>
                                            </span>
                                        </th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isLoading ? (
                                        <>
                                            <TableSkeleton rows={10} columns={6} />
                                        </>
                                    ) : (
                                        <>
                                            {sortedUsers.length === 0 ? (
                                                <>
                                                    <tr>
                                                        <td colSpan="6">No users found</td>
                                                    </tr>
                                                </>
                                            ) : (
                                                <>
                                                    {sortedUsers.map((user, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>{index + 1}</td>
                                                                <td>{user.name}</td>
                                                                <td>{user.email}</td>
                                                                <td>
                                                                    {user.email &&
                                                                        user.email.endsWith("isecurion.com")
                                                                        ? "Isecurion"
                                                                        : "Client"}
                                                                </td>
                                                                <td>{user.role}</td>
                                                                <td>{formatDate(user.createdAt)}</td>
                                                                <td>
                                                                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                                        <button
                                                                            onClick={() => {
                                                                                setDeleteUser(true);
                                                                                setSelectedUserId(user._id);
                                                                            }}
                                                                            style={{ background: "none", border: "none", cursor: "pointer" }}
                                                                        >
                                                                            <Icon
                                                                                icon="material-symbols:delete-outline"
                                                                                width="20"
                                                                                height="20"
                                                                                color="#F24822"
                                                                            />
                                                                        </button>

                                                                        {user.passwordEmailSent && (
                                                                            <button
                                                                                onClick={() => handleResendForgetLink(user._id)}
                                                                                style={{
                                                                                    fontSize: "14px",
                                                                                    background: "none",
                                                                                    border: "none",
                                                                                    color: "#007bff",
                                                                                    cursor: "pointer",
                                                                                }}
                                                                            >
                                                                                Resend
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                </td>

                                                            </tr>
                                                        );
                                                    })}
                                                </>
                                            )}
                                        </>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {openFeedbackForm &&
                    <Feedback
                        setOpenFeedbackForm={setOpenFeedbackForm} />}

                {openRegUser &&
                    <RegisterUser
                        setOpenRegUser={setOpenRegUser}
                        fetchRegisterUser={fetchRegisterUser} />}

                <Delete
                    deleteModalOpen={deleteUser}
                    setDeleteModalOpen={setDeleteUser}
                    handleDeleteUser={handleDeleteUser} />

            </div>

        </div >
    )
}

export default User;
